<!--
 * @Description: 通用底部
 * @Author: 山淑兰
 * @Date: 2019-12-26 14:19:26
 * @LastEditTime: 2020-05-26 10:45:42
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="footer" v-if="LogoTxt==null||LogoTxt==''">
		<div>
			大会官方网站内容未经允许，禁止拷贝或转载本站内容，禁止建立类似会议注册页面，否则追究法律责任！
		</div>
		<div class="toWebsite">
			<img src="../assets/Logo.png" alt="" />
			<span>提供技术支持</span>
		</div>
		<div>
			<span>京ICP备15000444号 </span>
			<span>京公网安备11011502003834号</span>
		</div>
	</div>
	<div id="footer" v-else style="padding: 15px 0;">
		<div class="footer-fixed">
			<a :href="LogoLink" target="_blank"><img style="height: 26px;" :src="LogoImg" /></a>
			{{LogoTxt}}
		</div>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from "vue-property-decorator";
	import {
		IMeetingInfo,
		current
	} from "@/contants/current";
	export default {
		name: 'liveInfo',
		data() {
			return {
				params: {
					m: '',
					red: '',
				},
				LogoTxt: '',
				LogoLink: '',
				LogoImg: '',

			}
		},
		created() {
			this.params = this.$route.query
			let opt = {
				m: this.params.m
			}
			this.initMeetingInfo()
		},
		mounted() {
			//this.swiperInit()
		},
		methods: {
			async initMeetingInfo() {
				let params = {
					m: this.params.m
				};
				let res = await IMeetingInfo.InitMeetingInfo(params);
				this.LogoTxt = res.LogoTxt
				this.LogoLink = res.LogoLink
				this.LogoImg = res.LogoImg
			},
		},
	}
</script>
<style scoped lang="scss">
	#footer {
		color: #aaa;
		font-size: 12px;
		text-align: center;
		padding: 20px 0;
		margin-top: 40px;
		border-top: 1px solid #eee;
		.footer-fixed{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		img {
			margin-right: 4px;
		}

		.toWebsite {
			margin: 4px;

			img {
				width: 70px;
				margin-right: 4px;
			}

			span {
				vertical-align: 8px;
			}
		}

		>div:last-child {
			>span {
				margin-right: 8px;
			}
		}
	}
	#foot img {
		display: inline-block;
		vertical-align: top;
		height: 30px;
		margin-right: 10px;
	}
</style>
